interface ItemsToScrollBackwardParams {
    /** Индекс текущего слайда */
    currentSlideIndex: number;
    /** На сколько слайдов сдвигать по умолчанию */
    itemsToScroll: number;
}

/**
 * Расчитывает на сколько слайдов еще можно сдвинуться назад
 */
export const useItemsToScrollBackward = function (params: ItemsToScrollBackwardParams) {
    const { currentSlideIndex, itemsToScroll } = params;

    return Math.min(currentSlideIndex, itemsToScroll);
};
